var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ArboNode',{staticClass:"p-2",attrs:{"menu":_vm.menu,"selections":_vm.selections,"selected-menu-id":_vm.selectedMenuId},on:{"action":_vm.onAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }